var style = {
  backgroundColor: "#212529",
  borderTop: "1px solid #212529",
  textAlign: "center",
  padding: "20px",
  position: "fixed",
  left: "0",
  bottom: "0",
  height: "60px",
  width: "100%",
  color: "white",
};

var phantom = {
  display: "block",
  padding: "20px",
  height: "60px",
  width: "100%",
};

function Footer({ props }) {
  return (
    <div>
      <div style={phantom} />
      <div style={style}>{props}hello@lua.cash</div>
    </div>
  );
}

export default Footer;
